// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withLocalization from "../hocs/withLocalization";
import withErrorState from "../hocs/withErrorState";
import withPageInfo from "../hocs/withPageInfo";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import Navigation, { NAVIGATION_HEIGHT } from "../layouts/Navigation";
import Heading2 from "../styleguide/Heading2";
import Grid from "@material-ui/core/Grid";
import IntroCard from "./IntroCard";
import classnames from "classnames";
import { pad } from "../utils/helper";
import withEMobilityTopics from "../hocs/withEMobilityTopics";
import EMobilityBanner from "./EMobilityBanner";
import { HEADER_HEIGHT } from "../layouts/Header";
import routes from "./routes";
import introImage from "../assets/images/emobility.jpg";

const styles = (theme) => ({
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        paddingBottom: 20,
    },
    heading: {
        marginTop: 24,
        marginBottom: 32,
        "& > a": {
            position: "absolute",
            top: `-${HEADER_HEIGHT + NAVIGATION_HEIGHT}px`,
        },
    },
});

const EMobility = ({ classes, eMobilityTopics, generalTranslations }) => {
    return (
        <React.Fragment>
            <Navigation />
            <div
                style={{
                    flex: "1 0 auto",
                    background: "#fafafa",
                    paddingTop: NAVIGATION_HEIGHT,
                }}
            >
                <EMobilityBanner
                    heading="E-Mobility Knowledge"
                    description={generalTranslations("e-mobility-intro-text")}
                    src={introImage}
                />
                <div className={classes.sectionsWrapperStyle}>
                    <div className={classes.containerStyle}>
                        <Heading2 className={classnames(classes.headingStyle, classes.heading)}>
                            <a name="topics" />
                            {generalTranslations("e-mobility-overview")}
                        </Heading2>
                        <div>
                            <Grid container spacing={24}>
                                {eMobilityTopics &&
                                    eMobilityTopics.map((topic, index) => (
                                        <IntroCard
                                            key={topic.id}
                                            number={pad(topic.order, 2)}
                                            title={topic.title}
                                            disabled={!topic.active}
                                            image={topic.thumbnail}
                                            intro={topic.intro}
                                            slug={topic.slug}
                                            baseRoute={routes.eMobility}
                                        />
                                    ))}
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default compose(
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    withErrorState,
    withPageInfo,
    withRouter,
    withEMobilityTopics(),
    withStyles(sharedComponentStyles),
    withStyles(styles)
)(EMobility);



// WEBPACK FOOTER //
// ./src/emobility/EMobility.js